import { Route, Routes } from "react-router-dom";
import React, { Suspense } from "react";
import MaintenanceDashboard from "../../../views/Mantenimiento/Dashboard/DashboardM";
import ControlVehicular from "../../../views/Mantenimiento/ControlVehicular/ControlVehicular";
import UnitsCatalog from "../../../views/Mantenimiento/UnitsCatalog/UnitCatalog/UnitsCatalog";
import BitacorasTaller from "../../../views/Mantenimiento/BitacorasTaller/BitacorasTaller";
import ServiceFormDialog from "../../../views/Mantenimiento/UnitsCatalog/UnitCatalog/Components/ServiceFormDialog";
import UnitsList from "../../../views/Mantenimiento/UnitsCatalog/UnitsList";
import ChecklistDiario from "../../../views/Mantenimiento/ChecklistDiario/ChecklistDiario";
import Proveedores from "../../../views/Mantenimiento/Proveedores/Proveedores";
import Catalogos from "../../../views/Mantenimiento/Catalogos/Catalogos";
const Mantenimiento = () => {
    return (
        <Routes>
            <Route exact path="/mantenimiento/dashboard"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <MaintenanceDashboard/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/control-vehicular"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <ControlVehicular/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/catalogos-unidades"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <UnitsList/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/catalogos-unidades/:id"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <UnitsCatalog/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/catalogos-unidades/nuevo"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <UnitsCatalog/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/bitacoras-taller"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <BitacorasTaller/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/mantenimiento/proveedores-taller"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Proveedores/>
                       </Suspense>
                   }>
            </Route>
        <Route exact path="/mantenimiento/bitacoras-taller/dialog"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <ServiceFormDialog/>
                       </Suspense>
                   }>
            </Route>
        <Route exact path="/mantenimiento/checklist-diario"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <ChecklistDiario/>
                       </Suspense>
                   }>
            </Route>
        <Route exact path="/mantenimiento/catalogos"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Catalogos/>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )
}

export default Mantenimiento
